import { FC, useEffect, useState } from "react";
import config from "config/index";
import CustomLink from "@Components/CustomLink";
// import Constants from "locales/lang"json";

import {
  addCountryWiseContactInfo,
  footerListLeft,
  footerListRight,
  footerListLeftChina,
  footerListRightChina,
} from "./constant";
import classes from "./FooterDesktop.module.scss";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import getImagePath from "@Utils/getImagePath";
import {
  AMBER_LOGO_URL,
  BLOG_URL,
  CONTACT_URL,
  EXAMS_URL,
  PRIVACY_URL,
  SITEMAP_URL,
  TERMS_URL,
} from "constants/configConstants";
import getSiteNavSchema from "./util";
import wrapperHOC from "@Utils/wrapperHOC";
import FooterDesktopChina from "./components/FooterDesktopChina/FooterDesktopChina";
import FollowUsChina from "./components/FollowUs/FollowUsChina";
import FollowUs from "./components/FollowUs/FollowUs";
import AppDownload from "./components/AppDownload/AppDownload";
import ContactCard from "./components/ContactCard/ContactCard";
import LazyImage from "@Components/Image";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import HelmetServer from "@Components/HelmetServer";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import TrustPilotDynamicWidget from "@Components/TrustPilotDynamicWidget";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
import { SCREEN_SIZE, useResponsiveness } from "hooks/useResponsiveness";
import FooterV2 from "./FooterV2";
import { isRegionalBlogLanguage } from "@Pages/Blog/utils/blogLanguage";
import { useLanguagePath } from "hooks/useLanguagePath";

const FooterDesktop: FC = () => {
  const { isBelow } = useResponsiveness();
  const isBelowLG = isBelow(SCREEN_SIZE.LG);
  const date = new Date();
  const year = date.getFullYear();
  const handleClickEvent = (buttonName: string) => {
    gtagEventEmitter({
      action: "bottom_button_clicked",
      category: "Footer Section",
      button_name: buttonName,
    });
  };
  const { country, nonce } = useSelector(
    ({ appData }: AppState) => ({ country: appData.country, nonce: appData.nonce }),
    shallowEqual,
  );
  const userLanguage = useSelector(({ appData }: AppState) => appData.userLanguage);
  const blogUrl = isRegionalBlogLanguage(userLanguage) ? `/${userLanguage}/blog` : "/blog";

  const [contactDetails, setContactDetails] = useState([]);
  const { t } = useTranslationHook();
  const { getLocalizedPath } = useLanguagePath();

  useEffect(() => {
    const closeZendeskWidgetBeforeUnload = () => {
      // if (typeof zE === "function") {
      //   zE("messenger", "close");
      // }
    };
    window.addEventListener("beforeunload", closeZendeskWidgetBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", closeZendeskWidgetBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const resolveContactInfo = async () => {
      const val: any = addCountryWiseContactInfo(country);
      setContactDetails(val);
    };
    resolveContactInfo();
  }, [country]);
  if (isBelowLG) return <FooterV2 />;
  if (config.IS_CHINA_APP) return <FooterDesktopChina />;
  return (
    <section className={classes.footerContainer}>
      <div className={classes.container} data-testid="footer-section">
        <div className={classes.mainDesktopContainer}>
          {/* {Section 1} */}

          <div className={classes.leftContainer}>
            <LazyImage
              dataTestId="footer-Amber-logo"
              src={
                config.IS_CHINA_APP
                  ? `${config.IMAGE_STATIC_URL}/images/logo/amber-china-logo-dark.svg?auto=format&q=40`
                  : getImagePath(AMBER_LOGO_URL)
              }
              className={formatClassNames(classes.amberImg, config.IS_CHINA_APP && classes.china)}
              alt="amber-div"
              width={config.IS_CHINA_APP ? "100" : "86px"}
              height={config.IS_CHINA_APP ? "50" : "34.05px"}
            />
            <div
              data-testid="footer-amber-rights-reserved"
              className={classes.subHeading}
            >{`amber © ${year}. ${t("home.footer.allrightsreserved")}`}</div>
            <div className={classes.trustpilotWrapperDesktop}>
              <TrustPilotDynamicWidget />
            </div>
            <AppDownload isDesktop />
            {/* </div> */}
          </div>
          {/* {Section 2} */}
          <div className={classes.subContainer}>
            <div className={classes.child}>
              <div className={classes.sectionOneContainer}>
                <div data-testid="footer-company-section" className={classes.sectionHeading}>
                  {t("home.footer.company")}
                </div>
              </div>
              {config.IS_CHINA_APP ? (
                <>
                  {footerListLeftChina.map((item: any, index) => (
                    <div className={classes.listItem} key={index}>
                      <HelmetServer>
                        <script type="application/ld+json" suppressHydrationWarning nonce={nonce}>
                          {getSiteNavSchema(item.name, item.link)}
                        </script>
                      </HelmetServer>
                      <CustomLink
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        isExternal
                        dataTestId={item.name}
                        onClick={() => handleClickEvent(item.gaKey)}
                      >
                        {t(item.name)}
                      </CustomLink>
                      {item.extraText && (
                        <span data-testid="footer-option-tag">{t(item.extraText)}</span>
                      )}
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {footerListLeft.map((item: any, index) => (
                    <div className={classes.listItem} key={index}>
                      <HelmetServer>
                        <script type="application/ld+json" suppressHydrationWarning nonce={nonce}>
                          {getSiteNavSchema(item.name, item.link)}
                        </script>
                      </HelmetServer>
                      <CustomLink
                        href={item.localize ? getLocalizedPath(item.link) : item.link}
                        target="_blank"
                        rel="noreferrer"
                        isExternal
                        dataTestId={item.name}
                        onClick={() => handleClickEvent(item.gaKey)}
                      >
                        {t(item.name)}
                      </CustomLink>
                      {item.extraText && (
                        <span data-testid="footer-option-tag">{t(item.extraText)}</span>
                      )}
                    </div>
                  ))}
                </>
              )}
            </div>
            <div className={classes.child}>
              <div className={classes.sectionOneContainer}>
                <div data-testid="footer-discover-section" className={classes.sectionHeading}>
                  {t("home.footer.discover")}
                </div>
              </div>
              {config.IS_CHINA_APP ? (
                <>
                  {footerListRightChina.map((item: any, index) => (
                    <div className={classes.listItem} key={index}>
                      <HelmetServer>
                        <script type="application/ld+json" suppressHydrationWarning nonce={nonce}>
                          {getSiteNavSchema(item.name, item.link)}
                        </script>
                      </HelmetServer>
                      <CustomLink
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        isExternal
                        dataTestId={item.name}
                        onClick={() => handleClickEvent(item.gaKey)}
                      >
                        {t(item.name)}
                      </CustomLink>
                      {item.extraText && <span>{t(item.extraText)}</span>}
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {footerListRight.map((item: any, index) => {
                    let href = item.link;
                    if (item.link === BLOG_URL) href = blogUrl;
                    else if (item.localize) href = getLocalizedPath(item.link);
                    return (
                      <div
                        className={formatClassNames(
                          classes.listItem,
                          item.link === EXAMS_URL && classes.hiddenForUsers,
                        )}
                        key={index}
                      >
                        <HelmetServer>
                          <script type="application/ld+json" suppressHydrationWarning nonce={nonce}>
                            {getSiteNavSchema(
                              item.name,
                              item.link === BLOG_URL ? blogUrl : item.link,
                            )}
                          </script>
                        </HelmetServer>
                        <CustomLink
                          href={href}
                          target="_blank"
                          rel="noreferrer"
                          isExternal
                          dataTestId={item.name}
                          onClick={() => handleClickEvent(item.gaKey)}
                        >
                          {t(item.name)}
                        </CustomLink>
                        {item.extraText && <span>{t(item.extraText)}</span>}
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
          {/* {Section 3} */}
          <div className={classes.supportSection}>
            <div style={{ cursor: "default" }}>
              <div data-testid="footer-support-section" className={classes.sectionHeading}>
                {t("home.footer.support")}
              </div>
            </div>
            <div className={classes.listItem}>
              <CustomLink
                href={getLocalizedPath("/help")}
                target="_blank"
                rel="noreferrer"
                isExternal
                dataTestId="Help Center"
                onClick={() => handleClickEvent("Help Center")}
              >
                {t("home.footer.helpcenter")}
              </CustomLink>
            </div>
            <div className={classes.listItem}>
              <HelmetServer>
                <script type="application/ld+json" suppressHydrationWarning nonce={nonce}>
                  {getSiteNavSchema("Contact", CONTACT_URL)}
                </script>
              </HelmetServer>
              <CustomLink
                href="/contact"
                target="_blank"
                rel="noreferrer"
                isExternal
                dataTestId="contact"
                onClick={() => handleClickEvent("Contact")}
              >
                {t("home.footer.contact")}
              </CustomLink>
            </div>
            <div className={classes.listItem}>
              <HelmetServer>
                <script
                  type="application/ld+json"
                  suppressHydrationWarning
                  nonce={nonce}
                  dangerouslySetInnerHTML={{
                    __html: getSiteNavSchema(
                      "Terms and Conditions",
                      replaceAmberDomainInLinks(TERMS_URL),
                    ),
                  }}
                />
              </HelmetServer>
              <CustomLink
                href={getLocalizedPath("/terms")}
                target="_blank"
                rel="noreferrer"
                isExternal
                dataTestId="T&C"
                onClick={() => handleClickEvent("Terms and Conditions")}
              >
                {t("home.footer.tnc")}
              </CustomLink>
            </div>
            <div className={classes.listItem}>
              <HelmetServer>
                <script type="application/ld+json" suppressHydrationWarning nonce={nonce}>
                  {getSiteNavSchema("Privacy Policy", PRIVACY_URL)}
                </script>
              </HelmetServer>
              <CustomLink
                href={getLocalizedPath("/privacy")}
                target="_blank"
                rel="noreferrer"
                isExternal
                dataTestId="Privacy Policy"
                onClick={() => handleClickEvent("Privacy Policy")}
              >
                {t("home.footer.privacypolicy")}
              </CustomLink>
            </div>
            <div className={classes.listItem}>
              <HelmetServer>
                <script type="application/ld+json" suppressHydrationWarning nonce={nonce}>
                  {getSiteNavSchema("Sitemap", SITEMAP_URL)}
                </script>
              </HelmetServer>
              <CustomLink
                href="/sitemap"
                target="_blank"
                rel="noreferrer"
                isExternal
                dataTestId="Sitemap"
                onClick={() => handleClickEvent("Sitemap")}
              >
                {t("home.footer.sitemap")}
              </CustomLink>
            </div>
          </div>
          {/* {Section 4} */}
          <div className={classes.contactUsSection}>
            <div data-testid="footer-contactUs-section" className={classes.sectionText}>
              {t("home.footer.contactus")}
            </div>
            {contactDetails?.map((contactDetail: any) =>
              !contactDetail.isVisibleForChina && config.IS_CHINA_APP ? (
                <></>
              ) : (
                <ContactCard
                  key={contactDetail.label}
                  icon={contactDetail.icon}
                  label={contactDetail.label}
                  link={contactDetail.link}
                />
              ),
            )}
            {config.IS_CHINA_APP ? <FollowUsChina /> : <FollowUs isMobile={false} />}
          </div>
        </div>
      </div>
    </section>
  );
};
export default wrapperHOC(FooterDesktop, {
  componentName: "FooterDesktop-FooterV2-Global",
  showForChina: true,
});
